export default __webpack_public_path__ + "1703c8b1031be0f33bedae5a7a7627b6.png";